// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取menu目录
export function getMenu(params) {
  return request({
    url: "/api/config/column",
    method: "get",
    params,
  });
}




// 配置列表
export function getConfig(params) {
  return request({
    url: "/api/config/config",
    method: "get",
    params,
  });
}